module.exports = __webpack_public_path__ + "media/tase/favicon-da389e83.ico";